import { CommonBaseData } from "../../data";

export class HeadMenuMainData extends CommonBaseData {
  public pgmId: string;
  public daikouFlg: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/header-menu/header-menu-data.ts